module.exports = __webpack_public_path__ + "static/media/background8fb2be3cc178f3b00efaaa485de21b5c.webp";